import { createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = /*#__PURE__*/_createElementVNode("h2", null, "小程序门店专属推广码下载", -1)
const _hoisted_2 = /*#__PURE__*/_createTextVNode("下载")

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_el_table_column = _resolveComponent("el-table-column")!
  const _component_el_link = _resolveComponent("el-link")!
  const _component_el_table = _resolveComponent("el-table")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _hoisted_1,
    _createVNode(_component_el_table, {
      data: _ctx.state.tableData,
      stripe: "",
      style: {"width":"50%"}
    }, {
      default: _withCtx(() => [
        _createVNode(_component_el_table_column, {
          prop: "width",
          label: "小程序码边长"
        }, {
          default: _withCtx((scope) => [
            _createTextVNode(_toDisplayString(scope.row.qrcode_width) + "cm", 1)
          ]),
          _: 1
        }),
        _createVNode(_component_el_table_column, {
          prop: "width",
          label: "建议扫描距离"
        }, {
          default: _withCtx((scope) => [
            _createTextVNode(_toDisplayString(scope.row.distance) + "m", 1)
          ]),
          _: 1
        }),
        _createVNode(_component_el_table_column, {
          prop: "qr_url",
          label: "小程序码"
        }, {
          default: _withCtx((scope) => [
            _createVNode(_component_el_link, {
              type: "primary",
              onClick: ($event: any) => (_ctx.handleDownloadQrcode(scope.row.qr_url))
            }, {
              default: _withCtx(() => [
                _hoisted_2
              ]),
              _: 2
            }, 1032, ["onClick"])
          ]),
          _: 1
        })
      ]),
      _: 1
    }, 8, ["data"])
  ], 64))
}